import action from "../helpers/rest-client";
import { GetOneCourseOutDto } from "../types/course.dto";

export class ErrorCourse extends Error {}

class Course {
  public getAll(payload) {
    const perpage = payload?.pagination?.limit || 10;
    const page = payload?.pagination?.page;
    const query = new URLSearchParams(payload.filters).toString();

    return action
      .Get({
        url: `/course/all?${query}&page=${page}&perpage=${perpage}`,
      })
      .then((response) => {
        return { response: response.success.result.rows };
      })
      .catch((error) => {
        return { error };
      });
  }

  public getOne(payload: GetOneCourseOutDto) {
    return action
      .Get({
        url: `/course/${payload.idCourse}`,
      })
      .then((response) => {
        return { response: response.success.result };
      })
      .catch((error) => {
        return { error };
      });
  }
}

const course = new Course();
export default course;
